import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a26a1bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "thumbnail card" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "spinner d-flex justify-content-center align-items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "name user-select-none" }
const _hoisted_8 = {
  class: "card image-box add d-flex justify-content-center align-items-center",
  for: "newpic"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Upload image", -1))
const _hoisted_10 = {
  key: 0,
  class: "text-center fw-bold text-danger"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock($setup["draggable"], {
    class: "d-flex flex-wrap",
    list: $setup.files,
    "item-key": "img",
    disabled: !$props.reorderable || $setup.files.some(o => o.loading)
  }, {
    item: _withCtx(({element, index}) => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["image-box mb-2", {'mx-auto': $props.evenImages, 'me-2': !$props.evenImages, 'added': $setup.addedFiles[element.id] || !$props.showNotAddedWarning}]),
        style: {"overflow":"hidden"}
      }, [
        _createElementVNode("div", _hoisted_1, [
          (!element.loading)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "img",
                style: _normalizeStyle({backgroundImage: 'url(' + element.img + ')'}),
                onClick: $event => (_ctx.$emit('insertImage', element))
              }, null, 12, _hoisted_2))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)),
          _createElementVNode("div", {
            class: "delete",
            onClick: $event => ($setup.deleteFile(index))
          }, [
            _createVNode(_component_icon, { icon: "trash" })
          ], 8, _hoisted_6),
          (!element.loading && !$setup.addedFiles[element.id] && $props.showNotAddedWarning)
            ? (_openBlock(), _createBlock(_component_icon, {
                key: 2,
                class: "not-added",
                icon: "far fa-exclamation-circle"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(element.name), 1)
      ], 2)), [
        [_directive_tooltip, $setup.addedFiles[element.id] || !$props.showNotAddedWarning ? '' : `You haven't added this image to your post, click to insert it`, "top"]
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("input", {
        type: "file",
        accept: "image/*",
        id: "newpic",
        style: {"display":"none"},
        multiple: "multiple",
        onChange: $setup.newFile
      }, null, 32),
      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_icon, { icon: "plus" })
      ])), [
        [_directive_tooltip, 'Upload image']
      ]),
      ($setup.files.length == 0 && $props.showNoImagesWarning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Please upload at least one picture of your creation"))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["list", "disabled"]))
}